import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Transition } from 'react-transition-group';
var duration = {
  enter: 0,
  exit: 100
};

/**
 * __Fade__
 *
 * A fade in animation used for spotlights.
 *
 * @internal
 */
export var Fade = function Fade(_ref) {
  var hasEntered = _ref.hasEntered,
      children = _ref.children,
      onExited = _ref.onExited;
  return /*#__PURE__*/React.createElement(Transition, {
    in: hasEntered,
    timeout: duration,
    onExited: onExited,
    unmountOnExit: true,
    appear: true
  }, function (status) {
    var base = {
      transition: "opacity ".concat(duration.exit, "ms"),
      opacity: 0
    };
    var anim = {
      entered: {
        opacity: 1
      },
      exiting: {
        opacity: 0
      }
    };

    var style = _objectSpread(_objectSpread({}, base), anim[status]);

    return children(style);
  });
};